export default {

	init() {
		$('input.validate-custom').on('change', function(e) {
			const value = $(this).val();
			if($(this).hasClass('/[0-9]{3}-[0-9]{3}-[0-9]{4}/g')) {
				$(this).val(value.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'));
			}
		});

		$('input.validate-custom').each(function() {
			const value = $(this).val();
			if($(this).hasClass('/[0-9]{3}-[0-9]{3}-[0-9]{4}/g') && $(this).attr('autoformat') !== undefined) {
				this.removeAttribute('autoformat');
			}
		});
	}

};
